/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Library } from '../../../Library';
import { Document } from '../../../core/models/Document';
import { Node } from '../../../core/models/Node';

export abstract class AbstractReferenceLocalizationStrategy {
    PREFIX : string = "#/components/";

    /**
     * Warning: This method assumes that the definition and the represented object can be read from the same JSON,
     * i.e. effectively contain the same data.
     * @param {Node} source
     * @param {Node} target
     * @param {Document} model
     * @return {Node}
     */
    wrap<T extends Node>(source : Node, target : T, model : Document) : T {
        target._ownerDocument = model;
        target._parent = target;
        return <T><any>Library.readNode(Library.writeNode(source), target);
    }

    transform(source : any, transformName : (p1: string) => string, result : any) {
        if(result == null) throw Object.defineProperty(new Error("Result argument is null."), '__classes', { configurable: true, value: ['java.lang.Throwable','java.lang.Object','java.lang.RuntimeException','java.lang.IllegalArgumentException','java.lang.Exception'] });
        if(source != null) {
            {
                let array241 = /* entrySet */(o => { let s = []; for (let e in o) s.push({ k: e, v: o[e], getKey: function() { return this.k }, getValue: function() { return this.v } }); return s; })(source);
                for(let index240=0; index240 < array241.length; index240++) {
                    let e = array241[index240];
                    {
                        /* put */(result[(target => (typeof target === 'function')?target(e.getKey()):(<any>target).apply(e.getKey()))(transformName)] = <any>e.getValue());
                    }
                }
            }
        }
    }
}
AbstractReferenceLocalizationStrategy["__class"] = "io.apicurio.datamodels.openapi.visitors.dereference.AbstractReferenceLocalizationStrategy";



